export const CANCEL_RECORD_LIST = 'CANCEL_RECORD_LIST'
export const UPDATE_COUPON_INFO_RECORD = 'UPDATE_COUPON_INFO_RECORD'
export const UPDATE_COUPON_INFO_FALSE_RECORD = 'UPDATE_COUPON_INFO_FALSE_RECORD'
export const STAFF_INFO = 'STAFF_INFO'
export const MEMBER_APPOINTMENT_DATA = 'MEMBER_APPOINTMENT_DATA'



// WEBPACK FOOTER //
// ./src/pages/wx-member/cancel-coupon/store/mutations-types.js